module.exports = __webpack_public_path__ + "img/ktv-party_en.a9d22792.jpg";